import React from "react";
import NavBar from "./NavBar";
import Socials from "./Socials";
import "../../styles/landingPage.css";
import "../../styles/mywork.css";
export default function LandingPage() {
  return (
    <div className="landing">
      <div className="top-container">
        <div className="intro-container">
          <h2>Hello, my name is</h2>
          <h1>Jonah&nbsp;Tillman.</h1>
        </div>
        <NavBar />
      </div>
      <div className="center-container">
        <a href="/my-work" className="center-button">
          See My Work
        </a>
      </div>
      <div className="bottom-container">
        <Socials />
      </div>
    </div>
  );
}
